export class Regions {
    http;
    constructor(http) {
        this.http = http;
    }
    getRegions() {
        return this.http.get(`/api/regions`).json();
    }
}
